import React from 'react';
import ConsentLogs from '@/components/superadmin/ConsentLogs';

const SuperadminConsentLogs = () => {
  return (
    <div className="flex flex-col h-full bg-white rounded-lg p-5 shadow-sm border border-gray-200">
      <div className="flex-shrink-0 mb-6">
        <h2 className="text-xl font-bold tracking-tight">Consent Logs</h2>
        <p className="text-muted-foreground">
          View and manage GDPR consent logs for privacy compliance
        </p>
      </div>
      
      <ConsentLogs />
    </div>
  );
};

export default SuperadminConsentLogs;
